// extracted by mini-css-extract-plugin
export var icon = "_5n-1";
export var subtext = "_5n-0";